<template>
  <div id="app">
    <Loader />
    <router-view />
  </div>
</template>
<script>
import Loader from "@/components/layout/Loader";
export default {
  components: {Loader},
  async beforeMount() {
    try {
      // await this.$store.dispatch(`refreshState`);
    }catch (e) { console.error(e) }
  },
}
</script>
<style lang="scss">
@import "assets/css/styles";
</style>
